/**
 * Sur le staging, tous les environnements (dev, demo, preproduction) partagent le domaine parent stonecode.io :
 * le nom des cookies de token inclut le client et l'environnement pour ne pas mélanger leurs tokens
 * (ex : "jts_dev_token"). En production, les noms restent "token" / "refresh_token".
 * Même règle que RH (wbc), shop et mon-compte.
 */
export default function getAuthCookiePrefix(): string {
	if (typeof window === 'undefined') return '';
	const match = window.location.hostname.match(/^(dev|demo|preproduction)-/);
	return match ? `jts_${match[1]}` : '';
}
